import BaseAPI from '@/apis/base/baseApi';
import commonFn from '@/commons/commonFunction';
import {FormMultiPart} from '../base/httpclient';
class FileAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = 'File';
  controllerName = 'Files';

  /**
   * lấy link gọi download file
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   * @param {*} tenant :Dữ liệu công ty nào
   */
  getDownloadLink(type, file, name, tenant) {
    let url = [this.getAPIUrl(), 'download', type.toString()];
    if (file) {
      if (tenant) {
        url.push(tenant);
      }

      url.push(file);

      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  /**
   * Check xem file đã có trên temp chưa
   * @param {*} fileName
   * @return Promise
   */
  checkTempFile(fileName) {
    const url = [this.getAPIUrl(), 'check-temp', fileName].join('/');
    return this.getAsync({url});
  }

  /**
   * lấy link gọi file
   * trả về content-type theo type - không force downoad
   * @param {*} type : File gì
   * @param {*} file : tên file server
   * @param {*} name : Tên file lưu về
   */
  getFileLink(type, file, name, tenant) {
    let url = [this.getAPIUrl(), type.toString()];
    if (file) {
      if (tenant) {
        url.push(tenant);
      }

      url.push(file);

      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  /**
   * Lấy link preview inline
   * @param {*} type
   * @param {*} file
   * @param {*} name
   * @param {*} tenant
   * @returns
   */
  getFilePreviewLink(type, file, name, tenant) {
    let url = [this.getAPIUrl(), 'preview', type.toString()];
    if (file) {
      if (tenant) {
        url.push(tenant);
      }

      url.push(file);

      if (name) {
        url.push(name);
      }
    }
    url = url.filter(function (item) {
      return item;
    });
    return url.join('/');
  }

  /**
   * Upload file
   * @param {*} file : File upload
   * @param {*} type : Loại file
   */
  upload(file, type) {
    const data = new FormData();
    data.append('file', file);
    if (type) {
      data.append('type', type);
    }

    const request = {
      url: this.getAPIUrl(),
      data: data,
    };

    return this.postAsync(request, true, true, FormMultiPart);
  }

  /**
   * Upload nhiều file
   * @param {*} files : File upload
   * @param {*} type : Loại file
   */
  uploads(files, type) {
    const data = new FormData();
    files.forEach(file => {
      data.append('file', file, file.name);
    });
    if (type) {
      data.append('type', type);
    }

    const request = {
      url: [this.getAPIUrl(), 'multi'].join('/'),
      data: data,
    };

    return this.postAsync(request, true, true, FormMultiPart);
  }

  /**
   * lấy link gọi file
   * trả về content-type theo type - không force downoad
   * @param {*} type : File gì
   * @param {*} name : tên file server
   * @param {*} width : độ rộng ảnh
   * @param {*} height : chiều dài ảnh
   * @param {*} quantity : độ phân giải
   */
  getImageLink(type, name, width, height, quantity) {
    const url = [this.getAPIUrl(), 'image', type];
    if (name) {
      url.push(name);
      if (width) {
        url.push(width);
      }
      if (height) {
        url.push(height);
      }
    }
    const context = JSON.parse(commonFn.getLocalStorage('Context'));
    if (context.TenantID) {
      url.push(context.TenantID);
    }
    if (quantity) {
      url.push(quantity);
    }

    return url.join('/');
  }

  /**
   * @description Tạo link tài liệu mới sau khi đổi tên
   * @param {Object} payload
   * @returns {String} new Link
   * @author nvthinh 24.06.2024
   */
  getNewFileName(payload) {
    return this.getAPIUrl() + `/download/renaming?fileUrl=${payload.fileUrl}&fileName=${payload.fileName}`;
  }

  /**
   * @description Lưu file
   * @param {Number} type Loại file được lưu
   * @param {String} fileUrl Link đường dẫn
   * @param {String} fileName Tên file
   * @author nvthinh 5.11.2024
   */
  save(type, fileUrl, fileName) {
    const data = new FormData();
    data.append('type', type);
    data.append('fileUrl', fileUrl);
    data.append('fileName', fileName);

    const request = {
      url: this.getAPIUrl() + '/save',
      data: data,
    };

    return this.postAsync(request, true, true, FormMultiPart);
  }
  /**
   * Đẩy file pdf lên minIo
   * ndhieu3 11.11.2024
   * @param {*} file
   * @returns
   */
  uploadFilePdf(file) {
    let request = {
      url: this.getAPIUrl() + '/UploadPdf',
      data: file,
    };

    return this.postAsync(request, false, true, FormMultiPart);
  }
}

export default new FileAPI();
